import { Divider, Grid, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { createChatGPTPrompt, getChatGPTResponseByScope, IPrompt, scopeType } from 'wisestep-api';
import { WsButton } from 'wisestep-base';

import { useWorkspaceContext } from '../../../context';
import { success, warning } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { generateDefaultPayload } from '../utils/PromptHelper';

import PromptDialogForAdd from './PromptDialogForAdd';
import PromptDialogForEdit from './PromptDialogForEdit';
import PromptList from './PromptList';

const CandidateSummary = () => {
  const loggedInWorkspace = useWorkspaceContext();

  const setNotification = useNotificationStore((state) => state.setNotification);
  const [promptDataAsLoaded, setPromptDataAsLoaded] = useState<IPrompt[]>([]);
  const [promptData, setPromptData] = useState<IPrompt[]>([]);

  const [openPromptDialog, setOpenPromptDialog] = useState(false);
  const [openPromptDialogForEdit, setOpenPromptDialogForEdit] = useState(false);
  const [selectedPrompt, setSelecetdPrompt] = useState<IPrompt>({
    promptTitle: '',
    prompt: '',
    active: false,
    default: false,
    jdCount: 0,
    numberOfQuestion: 0,
    workspaceId: loggedInWorkspace.id ?? '',
    scope: scopeType.CANDIDATE_SUMMARY,
    numberOfWords: 250,
  });

  const [newPromptTitle, setNewPromptTitle] = useState('');
  const [newPromptDescription, setNewPromptDescription] = useState('');

  const savePrompt = async () => {
    try {
      const res = await createChatGPTPrompt(promptData);
      orderingPrompts(res.data);
      setNotification(success('Prompt Added Successfully'));
    } catch (error) {
      setNotification(warning('Something went wrong, Please try again.'));
    }
  };
  useEffect(() => {
    (async () => {
      try {
        const response = await getChatGPTResponseByScope(scopeType.CANDIDATE_SUMMARY);
        if (response.data.length === 0) {
          const response = await createChatGPTPrompt([
            generateDefaultPayload(scopeType.CANDIDATE_SUMMARY, loggedInWorkspace.id),
          ]);
          setPromptData(response.data);
          setPromptDataAsLoaded(response.data);
        } else {
          orderingPrompts(response.data);
        }
      } catch (error) {
        setNotification(warning('Something went wrong, Please try again.'));
      }
    })();
  }, [loggedInWorkspace.id, setNotification]);

  const orderingPrompts = (data) => {
    const sortedData = data.sort((a, b) => a.id - b.id);
    setPromptData(sortedData);
    setPromptDataAsLoaded(sortedData);
  };

  const handlePromptData = (value) => setPromptData(value);
  const handleSelecetdPrompt = (value) => setSelecetdPrompt(value);
  const handleOpenPromptDialogForEdit = (value) => setOpenPromptDialogForEdit(value);
  const handleOpenPromptDialog = (value) => setOpenPromptDialog(value);
  const handleNewPromptTitle = (value) => setNewPromptTitle(value);
  const handleNewPromptDescription = (value) => setNewPromptDescription(value);
  return (
    <>
      <Paper sx={{ padding: 2 }}>
        <Grid container xs={12} pl={1}>
          <Grid item container pt={0.1} justifyContent="space-between" mb={2}>
            <Grid item>
              <Typography sx={{ fontWeight: 700, fontSize: 22 }}>
                Candidate Summary Prompts
              </Typography>
            </Grid>
            <Grid item mr={6.5}>
              <WsButton size="large" onClick={() => setOpenPromptDialog(true)}>
                + Add Prompt
              </WsButton>
            </Grid>
          </Grid>
          <Grid item xs={12} mb={1}>
            <Divider />
          </Grid>
          {promptData.map((data, index) => (
            <PromptList
              data={data}
              key={index}
              promptData={promptData}
              index={index}
              defaultNumber={promptData[0].numberOfWords}
              onSetPromptdata={handlePromptData}
              onSelecetdPrompt={handleSelecetdPrompt}
              onOpenPromptDialogForEdit={handleOpenPromptDialogForEdit}
            />
          ))}
        </Grid>

        <Grid
          container
          justifyContent="flex-end"
          columnSpacing={2}
          p={2}
          sx={{
            width: '100%',
            marginTop: 2.5,
          }}
        >
          <Grid item>
            <WsButton onClick={() => setPromptData(promptDataAsLoaded)} variant="outlined">
              Discard
            </WsButton>
          </Grid>
          <Grid item mr={4}>
            <WsButton onClick={savePrompt}>Save</WsButton>
          </Grid>
        </Grid>
        {openPromptDialog && (
          <PromptDialogForAdd
            openPromptDialog={openPromptDialog}
            newPromptDescription={newPromptDescription}
            newPromptTitle={newPromptTitle}
            promptData={promptData}
            handleOpenPromptDialog={handleOpenPromptDialog}
            onNewPromptTitle={handleNewPromptTitle}
            onNewPromptDescription={handleNewPromptDescription}
            onSetPromptdata={handlePromptData}
          />
        )}
        {openPromptDialogForEdit && (
          <PromptDialogForEdit
            openPromptDialog={openPromptDialogForEdit}
            promptData={promptData}
            handleOpenPromptDialogForEdit={handleOpenPromptDialogForEdit}
            onSetPromptdata={handlePromptData}
            selectedPrompt={selectedPrompt}
          />
        )}
      </Paper>
    </>
  );
};

export default CandidateSummary;
